// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"396f63ca","457":"c1332d09","551":"c882bcaf","760":"bc9f36d7","940":"19653fdf"}[chunkId] + ".chunk.js";
};